export default {
	field: 'memo',
	name: 'Memo',
	width: '273px',
}
